module.exports = __webpack_public_path__ + "static/media/reload.a28bc8ea.svg";